interface CopyLinkIconProps {
  className?: string
}

export function CopyLinkIcon({ className }: CopyLinkIconProps) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      color="#414151"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.75 12.75H15.55C16.6701 12.75 17.23 12.75 17.6578 12.532C18.0341 12.3402 18.3405 12.0344 18.5322 11.658C18.7502 11.2302 18.7502 10.6702 18.7502 9.55005V3.95002C18.7502 2.82992 18.7502 2.26986 18.5322 1.84204C18.3405 1.46572 18.0341 1.15973 17.6578 0.967987C17.23 0.75 16.6703 0.75 15.5502 0.75H9.9502C8.83009 0.75 8.26962 0.75 7.8418 0.967987C7.46547 1.15973 7.15973 1.46572 6.96799 1.84204C6.75 2.26986 6.75 2.82997 6.75 3.95007V6.75007M0.75 15.5501V9.95007C0.75 8.82997 0.75 8.26986 0.967987 7.84204C1.15973 7.46572 1.46547 7.15973 1.8418 6.96799C2.26962 6.75 2.83009 6.75 3.9502 6.75H9.5502C10.6703 6.75 11.23 6.75 11.6578 6.96799C12.0341 7.15973 12.3405 7.46572 12.5322 7.84204C12.7502 8.26986 12.7502 8.82992 12.7502 9.95002V15.55C12.7502 16.6702 12.7502 17.2302 12.5322 17.658C12.3405 18.0344 12.0341 18.3402 11.6578 18.532C11.23 18.75 10.6703 18.75 9.5502 18.75H3.9502C2.83009 18.75 2.26962 18.75 1.8418 18.532C1.46547 18.3402 1.15973 18.0344 0.967987 17.658C0.75 17.2302 0.75 16.6702 0.75 15.5501Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
